// pages/CongTrinhThietKe/NhaPho/index.tsx
import { useState } from 'react'
import { PageHero, ProjectGrid, CtaSection, Pagination } from '../../../components'
import { useProjects } from '../../../features/projects/hooks/useProjects'
import { nhaPhoProjects } from '../../../data/nhaPhoProjects'
import useDocumentTitle from '../../../hooks/useDocumentTitle'
import './NhaPho.css'

const BREADCRUMBS = [
  { label: 'Trang chủ', path: '/' },
  { label: 'Công trình thiết kế', path: '/cong-trinh-thiet-ke' },
  { label: 'Nhà phố' },
]

const NhaPhoPage = () => {
  useDocumentTitle('Thiết Kế Nhà Phố - MAXCONST')
  
  useState(() => {
    try {
      sessionStorage.setItem('lastVisitedList', '/nha-pho')
      sessionStorage.setItem('lastVisitedListName', 'Nhà phố')
    } catch (e) {
      // ignore
    }
  })

  const {
    currentProjects,
    loading,
    error,
    currentPage,
    totalPages,
    totalCount,
    startIndex,
    endIndex,
    setCurrentPage,
    goToNextPage,
    goToPrevPage,
    getPageNumbers,
  } = useProjects({
    category: 'nha-pho',
    pages: 10,
  })

  return (
    <div className="nha-pho-page">
      {/* Hero */}
      <PageHero
        tag="Thiết Kế Nhà Đẹp"
        title="Thiết Kế Nhà Phố"
        titleHighlight="Nhà Phố"
        description="Khám phá các mẫu thiết kế nhà phố hiện đại, tối ưu công năng, phù hợp với xu hướng đô thị mới"
        breadcrumbs={BREADCRUMBS}
        stats={
          totalCount > 0
            ? [
                { number: `${totalCount}+`, label: 'Mẫu thiết kế' },
                { number: '10+', label: 'Năm kinh nghiệm' },
                { number: '100%', label: 'Cam kết chất lượng' },
              ]
            : undefined
        }
      />

      {/* Content */}
      <div className="container section">
        {/* Projects Grid */}
        <ProjectGrid
          projects={currentProjects}
          loading={loading}
          error={error}
        />

        {/* Pagination */}
        {!loading && !error && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalCount={totalCount}
            startIndex={startIndex}
            endIndex={endIndex}
            getPageNumbers={getPageNumbers}
            onPageChange={setCurrentPage}
            onPrev={goToPrevPage}
            onNext={goToNextPage}
          />
        )}

        {/* CTA */}
        <CtaSection
          title="Bạn Quan Tâm Đến Thiết Kế Nhà Phố?"
          titleHighlight="Thiết Kế"
          description="Liên hệ ngay với Maxconst để nhận tư vấn thiết kế và dự toán thi công trọn gói miễn phí"
        />
      </div>
    </div>
  )
}

export default NhaPhoPage
